class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.closeTimeout = null;

    this.addEventListener('mouseenter', this.openOnHover.bind(this));
    this.addEventListener('mouseleave', this.closeOnLeave.bind(this));
    this.addEventListener('focusin', this.clearCloseTimeout.bind(this));
    this.mainDetailsToggle.querySelector('summary').addEventListener('click', this.onSummaryClick.bind(this));
    this.addEventListener('keydown', this.onKeyDown.bind(this));
  }

  onToggle() {
    super.onToggle();
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', this.mainDetailsToggle.open);

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  isDesktop() {
    return window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches;
  }

  onSummaryClick(event) {
    // Hover has already opened the menu before a mouse click reaches summary.
    // Keep that click from immediately closing the menu again.
    if (this.isDesktop() && event.detail > 0 && this.mainDetailsToggle.open) {
      event.preventDefault();
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    }
  }

  onKeyDown(event) {
    if (event.key !== 'Escape') return;
    event.preventDefault();
    this.close();
    this.mainDetailsToggle.querySelector('summary').focus();
  }

  close() {
    this.clearCloseTimeout();
    super.close();
    if (this.header) this.header.preventHide = false;
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement) && !this.matches(':hover')) this.close();
    });
  }

  clearCloseTimeout() {
    if (!this.closeTimeout) return;
    clearTimeout(this.closeTimeout);
    this.closeTimeout = null;
  }

  openOnHover() {
    if (!this.isDesktop()) return;

    this.clearCloseTimeout();
    document.querySelectorAll('header-menu details[open]').forEach((details) => {
      if (details !== this.mainDetailsToggle) {
        details.removeAttribute('open');
        details.querySelector('summary')?.setAttribute('aria-expanded', false);
      }
    });
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', true);
  }

  closeOnLeave() {
    if (!this.isDesktop()) return;

    this.clearCloseTimeout();
    this.closeTimeout = setTimeout(() => {
      if (this.contains(document.activeElement)) return;
      this.close();
    }, 350);
  }
}

customElements.define('header-menu', HeaderMenu);
